import type { App } from 'vue'
import type { Router } from 'vue-router'

// Import modules
import authModule from '@/modules/auth'
import projectsModule from '@/modules/projects'

const modules = [authModule, projectsModule]

export default function registerModules(app: App, router: Router) {
  // Register each module
  modules.forEach((module) => {
    if (module.routes) {
      module.routes(router)
    }

    // Only call install if it exists
    if ('install' in module && typeof module.install === 'function') {
      module.install(app)
    }
  })
}
